import { Phone, Mail, Instagram, Facebook } from "lucide-react";
import { BRAND } from "../lib/constants";

export const Footer = ({ onBook }) => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-[#1A1A1A] noise-overlay"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-24 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
          <div className="md:col-span-6">
            <div className="flex items-center gap-4 mb-6">
              <img src={BRAND.logoUrl} alt="Revive" className="h-14 w-14 object-contain" />
              <div>
                <div className="font-display font-bold text-2xl text-white tracking-tight">REVIVE</div>
                <div className="font-mono-accent text-[10px] text-zinc-500">PRO DETAILING</div>
              </div>
            </div>
            <p className="text-zinc-400 max-w-md leading-relaxed">
              Premium hand-finished car detailing, paint correction and ceramic coating. Sydney & surrounds.
            </p>
            <button
              data-testid="footer-book-btn"
              onClick={onBook}
              className="mt-8 inline-flex items-center bg-[#DC2626] hover:bg-[#EF4444] text-white font-display font-bold uppercase tracking-wider text-sm px-7 py-4 transition-colors"
            >
              Book Now
            </button>
          </div>
          <div className="md:col-span-3">
            <div className="font-mono-accent text-[10px] text-zinc-500 mb-5">CONTACT</div>
            <ul className="space-y-3">
              <li>
                <a href={`tel:${BRAND.phoneRaw}`} className="text-zinc-200 hover:text-[#DC2626] flex items-center gap-3">
                  <Phone className="h-4 w-4" /> {BRAND.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${BRAND.email}`} className="text-zinc-200 hover:text-[#DC2626] flex items-center gap-3 break-all">
                  <Mail className="h-4 w-4" /> {BRAND.email}
                </a>
              </li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="font-mono-accent text-[10px] text-zinc-500 mb-5">FOLLOW</div>
            <div className="flex items-center gap-3">
              <a href={BRAND.socials.instagram} target="_blank" rel="noreferrer" className="w-11 h-11 border border-[#27272A] hover:border-[#DC2626] hover:text-[#DC2626] text-zinc-400 flex items-center justify-center">
                <Instagram className="h-5 w-5" />
              </a>
              <a href={BRAND.socials.facebook} target="_blank" rel="noreferrer" className="w-11 h-11 border border-[#27272A] hover:border-[#DC2626] hover:text-[#DC2626] text-zinc-400 flex items-center justify-center">
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Massive brand mark */}
        <div className="overflow-hidden">
          <div className="font-display font-bold uppercase text-white/[0.04] text-[18vw] leading-[0.8] tracking-tighter text-center select-none">
            REVIVE
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#1A1A1A] flex flex-col md:flex-row items-center justify-between gap-4 text-xs">
          <div className="font-mono-accent text-zinc-500">
            © {new Date().getFullYear()} REVIVE DETAILING · ALL RIGHTS RESERVED
          </div>
          <div className="font-mono-accent text-zinc-600">CRAFTED FOR THE OBSESSED</div>
        </div>
      </div>
    </footer>
  );
};
